import { Optional } from '@pogokid/util'
import { isUuid } from '@pogokid/util/lodash'

export function isValidProfileHandle(
  handle: Optional<string>,
  allowMe?: boolean
): boolean {
  if (allowMe && handle === 'me') return true
  if (isUuid(handle)) return true
  return (
    typeof handle === 'string' &&
    /[a-z0-9_]/.test(handle) &&
    (handle as string).length > 3
  )
}
